
import LAB from './LAB'
import TASK from './TASK'
export default [
  LAB,
  TASK,
]
